/**
 * The day's own menu, in the product's overflow idiom: the things she can do to a
 * day. Opening it costs nothing — every dialog behind it reads the day through
 * the product's own command read, and none mounts until she chooses it.
 * **Optimize** prices two drive times on top of that read; **View Route** draws
 * the day on the product's own route map.
 *
 * One component for both views, so the week column's menu and My day's header
 * menu cannot drift apart in wording. The week column adds **View schedule**
 * (Pete, 2026-09-19: *"'Open day' on the context menu should be 'View
 * schedule'"*); My day, already being the day, does not. The confirmation round's
 * **Delay** is deliberately *not* here: it lives on My week's own header, where
 * somebody racing the clock can reach it without first finding tomorrow (Pete,
 * 2026-09-19).
 */
import { useState } from "react";
import { IconButton, ListItemText, Menu, MenuItem } from "@mui/material";
import MoreHoriz from "@mui/icons-material/MoreHoriz";

export function DayMenu({
  label,
  canSequence,
  onOpenDay,
  onAddBlock,
  onSequence,
  onViewRoute,
}: {
  /** "Thu Sep 24" — what the button announces itself as. */
  label: string;
  canSequence: boolean;
  /** **View schedule**. Absent on My day, which is already the day. */
  onOpenDay?: () => void;
  onAddBlock: (anchor: HTMLElement) => void;
  onSequence: () => void;
  onViewRoute: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const close = () => setAnchorEl(null);
  return (
    <>
      <IconButton size="small" aria-label={`Actions for ${label}`} onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreHoriz fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={close} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        {onOpenDay && (
          <MenuItem
            onClick={() => {
              close();
              onOpenDay();
            }}
          >
            <ListItemText>View schedule</ListItemText>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            // The popup anchors to the button that opened the menu, which stays
            // mounted; the menu item itself does not.
            const button = anchorEl;
            close();
            if (button) onAddBlock(button);
          }}
        >
          <ListItemText>Block time</ListItemText>
        </MenuItem>
        <MenuItem
          disabled={!canSequence}
          onClick={() => {
            close();
            onSequence();
          }}
        >
          <ListItemText>Optimize</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            close();
            onViewRoute();
          }}
        >
          <ListItemText>View Route</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
